import React from 'react'
import brainz from '../../images/Brainz.png'
import brainzChart from '../../images/BrainzChart.png'
import {
  BrainzContainer,
  BrainzBg,
  BrainzWrapper,
  ImgWrap,
  Img,
  TextWrapper,
  TextP,
  InfoGraphicWrapper,
  ChartContainer,
  TextH1
} from './BrainzElements.js'

const BrainzSection = () => {
  return (
    <>
      <BrainzContainer id="brainz">
        <BrainzBg />
        <BrainzWrapper>
          <ImgWrap>
            <Img src={brainz} />
          </ImgWrap>
          <InfoGraphicWrapper>
          <ChartContainer>
              <Img src={brainzChart} />
            </ChartContainer>
            <TextWrapper>
              <TextH1>What Are $BRAINZ?</TextH1>
              <TextP>$BRAINZ is a utility token that is yielded by all Bit Monsters. The token will be used within the Bit Monsters ecosystem and have a wide variety of uses.</TextP>
              <TextP> $BRAINZ has no real world value. 1 $BRAINZ = 1 $BRAINZ</TextP>
              <TextH1>Token Generation Rates</TextH1>
              <TextP>Bit Monsters generate $BRAINZ at different rates. All Bit Monsters start with the genesis trait and yield a base amount of 2 $BRAINZ per day. There is a 1% chance
                to also get the Superyield trait which means your Bit Monster will generate 1 more token per day. Legendaries will generate 4 $BRAINZ per day and can also get the superyield trait for a maximum total of 5 $BRAINZ per day.
                </TextP>              
              <TextH1>What Is Mutation?</TextH1>
              <TextP>Mutating allows you to have a chance of transferring a trait from one of your Bit Monsters to another. There is a 33% chance of losing the trait 
                from your original Bit Monster. The chance of a successful mutation can be found using the formula: $BRAINZ / ($BRAINZ + 3)
              </TextP>
            </TextWrapper>
          </InfoGraphicWrapper>
        </BrainzWrapper>
      </BrainzContainer>
    </>
  )
}

export default BrainzSection